import React from 'react';
import PermissionGroupUserRow from './permissiongroupuserrow';
import {useSelector} from 'react-redux';

function PermissionGroupUsersList(props) {
	const userPermissions = useSelector((store) => store.userPermissions);

	return (
		<section id="tablebodycontainer" className="customScrollbar userlist-body">
			<section className="userlistholder">
				{props.list.map((item, index) => (
					<PermissionGroupUserRow
						key={index + item.emailAddress}
						data={item}
						onDeleteClick={props.onDeleteClick}
						permissions={userPermissions?.permissions || {}}
					/>
				))}
			</section>
		</section>
	);
}

export default PermissionGroupUsersList;
